import { Outlet, useLocation } from "react-router-dom";
import "./App.css";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import WhatsAppButton from './components/WhatsAppButton'
function App() {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith("/admin-panel");
  const isHomeRoute = location.pathname === "/"; // Add check for home route
  const isEventSRoute = location.pathname === "/EventS";
  const isExamCellSRoute = location.pathname === "/Exam Cell";
  const isAdminloginRoute = location.pathname === "/admin-login"; 
  const isMainPageRoute = location.pathname === "/mainpage"; 

  const mainClass = isEventSRoute || isExamCellSRoute ? "" : "min-h-screen pt-0";

  return (
    <div>
      <main className={mainClass}>
        {/* Conditionally render Navbar based on route */}
        {!isAdminRoute &&  !isAdminloginRoute && !isHomeRoute && !isMainPageRoute  && <Navbar />}
        <Outlet />
      </main>
      {/* Conditionally render Footer based on route */}
      {!isAdminRoute &&  !isAdminloginRoute &&  <Footer /> }
      <WhatsAppButton/>
    </div>
  );
}

export default App;


